import React from "react";

//MUI
import CssBaseline from '@mui/material/CssBaseline';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { Grid, Box,  useTheme, useMediaQuery, } from "@mui/material";
import Link from '@mui/material/Link';

import Copyright from "../components/CopyRights.js";

import aboutBG from '../assets/about_BG.png'
import about1 from '../assets/About1.jpg'
import about2 from '../assets/About2.jpg'


const About = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    return (
        <Grid container component="main" 
            sx={{ 
                height: '100vh', 
                paddingTop: '55px', 
                position: 'relative',
                
                backgroundAttachment: 'fixed',
                backgroundImage: `url(${aboutBG})`,
                backgroundRepeat: 'repeat',
                backgroundSize: isMobile ? '100%' : '33%',
                backgroundPosition: 'center',
                
            }}
        >
            <CssBaseline/>
        
            <Grid container justifyContent="center">
                <Grid item xs={12} sm={10} md={8} lg={6}>
                    <Paper align='center' elevation={5} sx={{ marginTop: 4, padding: 4 }}>
                        <Typography component="h1" variant="h4"paddingTop={'20px'}>
                            เกี่ยวกับเรา
                        </Typography>
                    
                        <Typography sx={{ textIndent: '2em' }} component="h1" variant="body1" align="left" paddingTop={'15px'} paddingLeft={'25px'} paddingRight={'25px'} paddingBottom={'20px'}>
                        เราเป็นโรงงานผู้ผลิตชั้นนำที่เชี่ยวชาญในการผลิต กระเป๋า เสื้อผ้า และของขวัญของพรีเมี่ยม สำหรับลูกค้าองค์กร ด้วยประสบการณ์และความเข้าใจในความต้องการของตลาด เราพร้อมส่งมอบสินค้าที่มีคุณภาพสูงและสามารถปรับแต่งได้ตามแบรนด์ของคุณ
                        เรารับผลิต กระเป๋าทุกชนิด เช่น กระเป๋าผ้า กระเป๋าเป้ กระเป๋าเดินทาง และกระเป๋าโน้ตบุ๊ก ตอบโจทย์ทั้งการใช้งานและการส่งเสริมภาพลักษณ์ของแบรนด์ นอกจากนี้ เรายังผลิต เสื้อโปโล เสื้อแจ็กเก็ต และยูนิฟอร์ม สำหรับบริษัท โรงเรียน และกิจกรรมองค์กรต่างๆ
                        ในส่วนของของขวัญ เรายังผลิต ของพรีเมี่ยมหลากหลายประเภท เช่น กระบอกน้ำเก็บความร้อน ร่มพรีเมี่ยม ชุดของขวัญ เครื่องเขียน และผ้าขนหนู พร้อมสกรีนหรือปักโลโก้ และบรรจุภัณฑ์ที่ดูดี เพื่อสร้างความประทับใจให้กับผู้รับ
                        เราให้บริการแบบครบวงจร ตั้งแต่การออกแบบ การผลิต ไปจนถึงการจัดส่งตรงเวลา พร้อมควบคุมคุณภาพในทุกขั้นตอน
                        </Typography>

                        <Box 
                            component="img" 
                            src={about1} 
                            alt="ช่างเย็บ1" 
                            sx={{ 
                            width: { xs: '50%', md: '25%' }, 
                            height: 'auto', 
                            borderRadius: 2, 
                            marginBottom: { xs: 3, md: 0 },
                            marginRight: { md: 3 }
                            }}
                        />
                        <Box 
                            component="img" 
                            src={about2} 
                            alt="ช่างเย็บ2" 
                            sx={{ 
                            width: { xs: '50%', md: '25%' }, 
                            height: 'auto', 
                            borderRadius: 2, 
                            marginBottom: { xs: 3, md: 0 },
                            marginRight: { md: 3 }
                            }}
                        />
                        <Box>
                            <Typography sx={{ textIndent: '2em' }} component="h1" variant="body1" align="left" paddingTop={'15px'} paddingLeft={'50px'} paddingRight={'50px'} paddingBottom={'50px'}>
                                เราคือทีมผู้ผลิตที่ผสมผสานประสบการณ์และความคิดสร้างสรรค์อย่างลงตัว ด้วยทีมช่างเย็บมืออาชีพที่มีประสบการณ์มากกว่า 20 ปีในสายงาน พร้อมด้วยคนรุ่นใหม่ที่มีไฟในการผลิตสินค้าคุณภาพ 
                                และนำเสนอไอเดียที่ทันสมัย เรามุ่งมั่นสร้างสรรค์ผลงานที่ตอบโจทย์ทุกความต้องการของลูกค้า ด้วยมาตรฐานที่คุณวางใจได้
                            </Typography>
                        </Box>
                         

                        <Copyright/>
                    </Paper>
                </Grid>
            </Grid>
        
        
        </Grid>
        
    );
};
 
export default About;